<template>
  <Menu />
  <Zapis />
  <Phone />
  <div class="pri">
    <div class="cen">
      <div class="lef">
        <div class="mr"></div>
        <h1>Шельтямова <br>
          Елена Олеговна
        </h1>
        <h2>врач-стоматолог-терапевт</h2>
        <p>
          Общий медицинский стаж с 2019 года. Стаж по специальности с 2021 года. Диплом о высшем образовании, выдан Федеральным государственным образовательным учреждением высшего профессионального образования «Чувашский государственный университет им. И.Н. Ульянова» в 2019 году, специальность «Стоматология», квалификация «врач-стоматолог».
Диплом об окончании ординатуры по специальности «Стоматология терапевтическая» выдан 05.07.2021 году ФГБОУ высшего образования «Чувашский государственный университет имени И.Н. Ульянова» г. Чебоксары.
Первичная специализированная аккредитация по специальности «Стоматология терапевтическая» пройдена в ФГБОУ высшего образования «Чувашский государственный университет имени И.Н. Ульянова» в 2021 году, срок действия аккредитации до 29.10.2026г. <br>
<b>График работы: по скользящему графику.</b> <br>
Персональные данные размещены на сайте на основании Постановления Правительства РФ от 11 мая 2023г. №736 и с согласия субъекта персональных данных, разрешенных для распространения. Запреты и условия на обработку неограниченным кругом лиц персональных данных не установлены.

        </p>
      </div>
      <div class="rig">
        <img class='ii' alt="" src="../assets/wum.jpg" />
      </div>
    </div>
  </div>
  <Map />
  <Foot />
</template>

<script>
import Menu from '@/components/Menu.vue'
import Zapis from '@/components/Zapis.vue'
import Phone from '@/components/Phone.vue'
import Map from '@/components/Map.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'PriceView',
  components: {
    Menu,
    Zapis,
    Phone,
    Map,
    Foot,
  }
}
</script>

<style scoped>

.pri {
  background-color: #f5ee92;
  height: 100vh;
  margin-top: -7.5vh;
}

.cen {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(530px, 1fr));
  margin: 0 auto;
}

.mr {
  height: 5vh;
}

h1 {
  font-size: 3vw;
  margin-left: 5vw;
}

h2 {
  font-size: 1.8vw;
  margin-left: 5vw;
}

p {
  margin-left: 5vw;
  margin-top: 5vh;
  font-size: 0.9vw;
  width: 40vw;
  line-height: 4vh;
}

.ii {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  object-fit: cover;
}

@media (max-width: 790px) {

  .pri {
    height: auto;
    margin-top: 0;
  }

  .cen {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }

  h1 {
    font-size: 28px;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
    width: 80vw;
  }

}

</style>

